import React from 'react';
import { Box, Typography, Button } from '@mui/material';

export const ACCENT = '#C9973A';

export default function DashboardLayout({ eyebrow, heading, subtitle, email, onLogout, children }) {
  return (
    <Box sx={{ width: '100%', minHeight: '100vh', display: 'flex' }}>

      {/* Left: brand panel */}
      <Box
        sx={{
          flex: '1 1 50%',
          minHeight: '100vh',
          position: 'relative',
          background: 'linear-gradient(160deg, #16324F 0%, #0F2438 100%)',
          display: { xs: 'none', md: 'flex' },
          flexDirection: 'column',
          justifyContent: 'space-between',
          p: 8,
          overflow: 'hidden',
        }}
      >
        <Box
          component="svg"
          viewBox="0 0 420 420"
          sx={{ position: 'absolute', top: -80, right: -120, width: 420, height: 420, opacity: 0.12 }}
          aria-hidden="true"
        >
          <circle cx="210" cy="210" r="209" stroke={ACCENT} strokeWidth="1" fill="none" />
          <circle cx="210" cy="210" r="150" stroke={ACCENT} strokeWidth="1" fill="none" />
          <circle cx="210" cy="210" r="90" stroke={ACCENT} strokeWidth="1" fill="none" />
        </Box>

        <div />

        <Box sx={{ position: 'relative' }}>
          <Box sx={{ width: 56, height: 3, background: ACCENT, mb: 3 }} />
          <Typography sx={{ fontFamily: "'Lora', serif", fontWeight: 600, fontSize: 56, lineHeight: 1.1, color: '#FFFFFF', letterSpacing: '-0.5px' }}>
            HirePeaks
          </Typography>
          <Typography sx={{ fontSize: 18, color: '#B9C4D0', mt: 2, maxWidth: 380, lineHeight: 1.5 }}>
            IT staffing and recruitment, simplified for teams that move fast.
          </Typography>
        </Box>

        <Typography sx={{ position: 'relative', fontSize: 13, color: '#7C8FA3', letterSpacing: '0.4px' }}>
          HIREPEAKS CONSULTING LLP
        </Typography>
      </Box>

      {/* Right: dashboard panel */}
      <Box sx={{ flex: '1 1 50%', minHeight: '100vh', display: 'flex', flexDirection: 'column', p: { xs: 3, md: 6 } }}>

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 2.5 }}>
          <Box sx={{ textAlign: 'right' }}>
            <Typography sx={{ fontSize: 12, color: '#8A93A0' }}>Signed in as</Typography>
            <Typography sx={{ fontSize: 14, color: '#1B2430', fontWeight: 600 }}>{email}</Typography>
          </Box>
          <Button
            variant="outlined"
            size="small"
            onClick={onLogout}
            sx={{ color: '#16324F', borderColor: '#C9CDD4', '&:hover': { borderColor: '#16324F', background: '#F2F4F6' } }}
          >
            Log Out
          </Button>
        </Box>

        <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', maxWidth: 480, width: '100%' }}>
          <Typography sx={{ fontSize: 13, fontWeight: 700, letterSpacing: '1.2px', color: ACCENT, mb: 1.5 }}>
            {eyebrow}
          </Typography>
          <Typography sx={{ fontFamily: "'Lora', serif", fontSize: 34, fontWeight: 600, color: '#1B2430' }}>
            {heading}
          </Typography>
          <Typography sx={{ fontSize: 15, color: '#5B6472', mt: 1.25, lineHeight: 1.6 }}>
            {subtitle}
          </Typography>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 4.5 }}>
            {children}
          </Box>
        </Box>

        <div />
      </Box>
    </Box>
  );
}
